import { render, staticRenderFns } from "./ContractManagement.vue?vue&type=template&id=71f5cf45&scoped=true"
import script from "./ContractManagement.vue?vue&type=script&lang=js"
export * from "./ContractManagement.vue?vue&type=script&lang=js"
import style0 from "./ContractManagement.vue?vue&type=style&index=0&id=71f5cf45&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5cf45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f5cf45')) {
      api.createRecord('71f5cf45', component.options)
    } else {
      api.reload('71f5cf45', component.options)
    }
    module.hot.accept("./ContractManagement.vue?vue&type=template&id=71f5cf45&scoped=true", function () {
      api.rerender('71f5cf45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/ContractManagement.vue"
export default component.exports